import { ThemeColor } from '../@types/theme-color';

/**
 * Receives either a string color or an NSP color object and returns the
 * color as a readable hex string e.g. #ffffff.
 */
export default function nspColorAsString(color: ThemeColor): string {
  return typeof color === 'string' ? color : color?.hex;
}
